// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title__oU51A","sub_title":"loader_sub_title__aeZlv","grid":"loader_grid__Eu_N5"};